import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LandingPage from "./LandingPage";
import Gallery from "./Gallery";
import ContactPage from "./ContactPage";
import Footer from "./Footer";

const Router = () => {
  const Layout = () => {
    return (
      <>
        <Navbar />
        <Outlet />
        <Footer />
      </>
    );
  };

  const BrowserRoutes = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <LandingPage />,
        },

        {
          path: "/gallery",
          element: <Gallery />,
        },

        {
          path: "/contact-us",
          element: <ContactPage />,
        },
      ],
    },
  ]);
  return <RouterProvider router={BrowserRoutes} />;
};

export default Router;
